import { useTranslation } from 'react-i18next';
import Reveal from '@/components/base/Reveal';
import SectionHeader from '@/components/feature/SectionHeader';

interface ValueItem {
  title: string;
  desc: string;
}

const ICONS = ['ri-award-line', 'ri-shield-check-line', 'ri-verified-badge-line', 'ri-team-line'];

export default function ValuesSection() {
  const { t } = useTranslation();
  const items = t('about.values.items', { returnObjects: true }) as ValueItem[];

  return (
    <section className="bg-background-100 py-16 md:py-24">
      <div className="mx-auto w-full max-w-content px-4 md:px-6">
        <SectionHeader eyebrow={t('about.values.eyebrow')} title={t('about.values.title')} />

        <div className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {items.map((item, index) => (
            <Reveal key={item.title} delay={index * 90}>
              <article className="flex h-full flex-col rounded-lg border border-background-200 bg-background-50 p-6">
                <span className="flex h-12 w-12 items-center justify-center rounded-md bg-accent-100 text-2xl text-accent-700">
                  <i className={ICONS[index % ICONS.length]} />
                </span>
                <h3 className="mt-5 font-heading text-base font-semibold text-foreground-950">{item.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}